module.exports = __webpack_public_path__ + "img/QRM-Banner.c679757e.jpeg";